
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M12 22a10 10 0 0010-10A10 10 0 0012 2 10 10 0 002 12a10 10 0 0010 10zm0-2a8 8 0 01-8-8 8 8 0 118 8zm0-11.3A1.3 1.3 0 0012 6c-.8 0-1.4.7-1.4 1.4s.6 1.3 1.3 1.3zm-1.7 8.6h4c.3 0 .7-.4.7-.8s-.4-.7-.8-.7h-1v-4.6c0-.6-.4-1-.9-1h-1.8c-.5 0-.8.4-.8.8s.3.7.8.7h1v4h-1.2c-.4 0-.8.4-.8.8s.4.8.8.8z"}})])
          )
        }
      }
    